<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="formatDataBeforeSave"
        :useAdditionalSaveFunction="true"
        :additionalAfterSaveFunction="afterSaving"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ClearanceOfAdvances"
                        :label="$t('lang_LABEL_CONTRACTS_ADVANCE_CLEARANCE')"
                        :withMargin="false"
                        rules="required"
                        :iconTooltipText="$t('lang_CONTRACTS_LABEL_TOOLTIP_ADVANCE_CLEARANCE')"
                        :alvqa="alvqa + '-textfield-clearance-of-advances'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Credit"
                        :label="$t('lang_LABEL_CONTRACTS_ADVANCE_CREDIT')"
                        :withMargin="false"
                        rules="required|balanceNotGreaterThanZero"
                        :iconTooltipText="$t('lang_CONTRACTS_LABEL_TOOLTIP_CREDIT')"
                        :alvqa="alvqa + '-textfield-credit'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "LabelContractsAdvanceEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseIcon,
    },
    data() {
        return {
            context: 'LabelContractsAdvance',
            alvqa: "contracts-label-edit-form-panel-advance-editing-dialog"
        }
    },
    methods: {
        formatDataBeforeSave(item) {
            item.credit = this.$alvPlugin.stringToFloat(item.credit)
            item.enteredBy = this.$store.getters.getUserUsername
            item.enteredOn = new Date()

            return item
        },
        afterSaving() {
            this.$store.dispatch('calculateLabelContractsAdvanceBalance')
        }
    },
}
</script>